import React from "react";
import {Button, Space, Card, Row, Tooltip, Popconfirm, DatePicker, InputNumber} from "antd";
import {CheckCircleFilled, CloseCircleFilled} from "@ant-design/icons";

import config from "../../../../../_core/config";
import moment from "moment";
import {StatusItem} from "./CourierWalletSettings.styles";
import {useCourierWalletSettings} from "./useCourierWalletSettings";

export const CourierWalletSettings = ({
    courier,
    courierLoading = true,
    reloadCourier = () => {}
}) => {
    const {
        isWalletActive,
        courierDataValid,
        isStartDepositAmountCalculated,
        calculateCourierCreditLogSummary,
        creditLogCalculationLoading,
        isButtonDisabled,
        formik
    } = useCourierWalletSettings({courier, courierLoading, reloadCourier});

    return (
        <Card
            title="Kurye Cüzdan Bilgisi"
            style={{
                margin: "6px",
                width: "100%",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px"
            }}
        >
            <Space direction="vertical" size="middle" style={{width: "100%", marginBottom: "24px"}}>
                <StatusItem style={{gap: "5px"}}>
                    {courier?.iban ? (
                        <CheckCircleFilled className="icon success" />
                    ) : (
                        <CloseCircleFilled className="icon error" />
                    )}
                    <span className="label">IBAN bilgisi</span>
                </StatusItem>
                <StatusItem style={{gap: "5px"}}>
                    {courier?.taxNumber ? (
                        <CheckCircleFilled className="icon success" />
                    ) : (
                        <CloseCircleFilled className="icon error" />
                    )}
                    <span className="label">Vergi Numarası</span>
                </StatusItem>
            </Space>

            <form onSubmit={formik.handleSubmit}>
                <Space
                    direction="vertical"
                    size="middle"
                    style={{width: "100%", marginBottom: "0px"}}
                >
                    <Row>
                        <label>Kazanç başlangıç tarihi :</label>
                        <DatePicker
                            placeholder="Tarih seçimi"
                            style={{width: "100%"}}
                            onChange={value => calculateCourierCreditLogSummary(value)}
                            format="DD.MM.YYYY HH:mm"
                            defaultValue={moment()
                                .startOf("day")
                                .hour(18)
                                .minute(0)}
                            showTime
                            allowClear={false}
                            disabled={courierLoading || creditLogCalculationLoading}
                        />
                        <div style={{color: "rgba(0, 0, 0, 0.45)", fontSize: "14px"}}>
                            Kuryenin geçmiş kazançlarının, başlangıç bakiyesi olarak hesaplanması
                            için başlangıç tarihi seçiniz.
                        </div>
                    </Row>
                    <Row>
                        <div style={{width: "100%"}}>
                            <label>Yüklenecek Başlangıç Bakiyesi :</label>
                        </div>
                        <div style={{width: "100%"}}>
                            {creditLogCalculationLoading ? (
                                <span style={{color: "rgba(0, 0, 0, 0.45)"}}>Hesaplanıyor...</span>
                            ) : formik.values.startDepositAmount !== undefined ? (
                                <b style={{fontSize: "18px"}}>
                                    {" "}
                                    {formik.values.startDepositAmount.toLocaleString("tr-TR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}{" "}
                                    ₺
                                </b>
                            ) : (
                                <span style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                    Henüz Hesaplanmadı
                                </span>
                            )}
                        </div>
                        {/*  <InputNumber
                            placeholder="Başlangıç bakiyesi"
                            value={formik.values.startDepositAmount}
                            onChange={value => formik.setFieldValue("startDepositAmount", value)}
                            defaultValue={0}
                            disabled={courierLoading || creditLogCalculationLoading}
                        /> */}
                    </Row>
                    <Row>
                        <div style={{width: "100%"}}>
                            <label>Bloke Edilecek Bakiye :</label>
                        </div>
                        <div style={{width: "100%"}}>
                            <InputNumber
                                placeholder="Bloke Edilecek Bakiye"
                                value={formik.values.blockedBalance}
                                onChange={value => formik.setFieldValue("blockedBalance", value)}
                                defaultValue={config.defaultBlockedCourierBalance}
                                disabled={courierLoading || creditLogCalculationLoading}
                                min={0}
                            />
                        </div>
                    </Row>
                    <Row>
                        <Space direction="vertical" size="small" style={{width: "100%"}}>
                            <Tooltip
                                title={
                                    !courierDataValid()
                                        ? "Kurye bilgilerinin eksiksiz olduğundan emin olunuz."
                                        : !isStartDepositAmountCalculated()
                                        ? "Yüklenecek başlangıç bakiyesi henüz hesaplanmamış"
                                        : isWalletActive()
                                        ? "Cüzdan özelliği zaten aktifleştirilmiş"
                                        : ""
                                }
                            >
                                <Popconfirm
                                    title={
                                        <>
                                            Kurye için cüzdan oluşturmak istediğinize emin misiniz?{" "}
                                            <br />
                                            <br />
                                            Başlangıç Bakiyesi :{" "}
                                            <b>
                                                {formik?.values?.startDepositAmount?.toLocaleString(
                                                    "tr-TR",
                                                    {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }
                                                )}{" "}
                                                ₺
                                            </b>
                                            <br />
                                            Bloke Edilecek Bakiye :{" "}
                                            <b>
                                                {formik?.values?.blockedBalance?.toLocaleString(
                                                    "tr-TR",
                                                    {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }
                                                )}{" "}
                                                ₺
                                            </b>
                                            <br />
                                            <br />
                                            (Bu işlem geri alınamaz)
                                        </>
                                    }
                                    onConfirm={formik.handleSubmit}
                                    okText="Evet"
                                    cancelText="Hayır"
                                    disabled={isButtonDisabled}
                                >
                                    <Button
                                        type="primary"
                                        loading={
                                            formik.isSubmitting ||
                                            courierLoading ||
                                            creditLogCalculationLoading
                                        }
                                        disabled={isButtonDisabled}
                                    >
                                        {creditLogCalculationLoading
                                            ? "Hesaplanıyor..."
                                            : formik.isSubmitting
                                            ? "İşlem yapılıyor..."
                                            : "Cüzdan oluştur ve aktifleştir"}
                                    </Button>
                                </Popconfirm>
                            </Tooltip>
                        </Space>
                    </Row>
                </Space>
            </form>
        </Card>
    );
};
